import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AssigneeDropdown from "../../../Ticket/components/TicketDetailsComponent/TicketDetails/AssigneeDropdown";
import DueDateSelection from "../../../Ticket/components/TicketDetailsComponent/TicketDetails/DueDateSelection";
import PriorityDropdown from "../../../Ticket/components/TicketDetailsComponent/TicketDetails/PriorityDropdown";
import StatusDropdown from "../../../Ticket/components/TicketDetailsComponent/TicketDetails/StatusDropdown";
import TagsSelection from "../../../Ticket/components/TicketDetailsComponent/TicketDetails/TagsSelection";
import TicketTypeDropdown from "../../../Ticket/components/TicketDetailsComponent/TicketDetails/TicketTypeDropdown";
import {
  selectTicketFormDetail,
  selectTicketGroups,
} from "../../containers/Tickets/redux/selector";
import { actions } from "../../containers/Tickets/redux/slice";
import { selectTicketStatus } from "app/redux/selector";
import { GroupByTypeEnum } from "../../types";
import { getDefaultTicketFields } from "../../helpers";
import { selectDraftBoardForm } from "../Settings/redux/selector";
import { useParams } from "react-router-dom";

const ContextFields = () => {
  const { project } = useParams();
  const dispatch = useDispatch();
  const form = useSelector(selectTicketFormDetail);
  const statusData = useSelector(selectTicketStatus);
  const boardFormData = useSelector(selectDraftBoardForm);
  const groups = useSelector(selectTicketGroups);
  const handleSelect = (name: string, value) => {
    dispatch(actions.setTicketFormValue({ name: name, value: value }));
  };
  useEffect(() => {
    if (!statusData?.length) return;
    const defaultGroup = groups
      .filter((x) => x._id === project)
      .map((ele) => {
        return ele;
      });

    let defaultId = statusData[0]?._id;
    if (boardFormData.groupBy === GroupByTypeEnum.STATUS && defaultGroup[0]) {
      const resolved = getDefaultTicketFields(
        defaultGroup[0],
        GroupByTypeEnum.STATUS
      );
      const match = statusData.find((s) => s.name === resolved.status);
      if (match) defaultId = match._id;
    }
    dispatch(actions.setTicketFormValue({ name: "status", value: defaultId }));
  }, [statusData]);

  return (
    <div className="grid grid-cols-2 gap-[10px]">
      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center justify-between gap-[8px]">
          <TicketTypeDropdown
            value={form.type}
            setValue={(val) => {
              handleSelect("type", val);
            }}
          />
        </div>
        <div className="flex flex-row items-center justify-between gap-[8px]">
          <StatusDropdown
            value={form.status}
            setValue={(val) => {
              handleSelect("status", val);
            }}
          />
        </div>

        <div className="flex flex-row items-center justify-between gap-[8px]">
          <AssigneeDropdown
            value={form.assignedTo}
            setValue={(val) => {
              handleSelect("assignedTo", val);
            }}
          />
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center justify-between gap-[8px]">
          <DueDateSelection
            dueDate={form.dueDate}
            onDateChange={(val) => {
              handleSelect("dueDate", val);
            }}
          />
        </div>

        <div className="flex flex-row items-center justify-between gap-[8px]">
          <PriorityDropdown
            value={form.priority}
            setValue={(val) => {
              handleSelect("priority", val);
            }}
          />
        </div>

        <div className="flex flex-row items-center justify-between gap-[8px]">
          <TagsSelection
            selectedTags={form?.tags}
            onTagsChange={(tagIds) => {
              handleSelect("tags", tagIds);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContextFields;
